/* eslint-disable no-template-curly-in-string */
import { OccConfig } from '@spartacus/core';
import { EnvironmentConfiguration } from '../../../environments/models/environment.model';

export const customOccConfig = (env: EnvironmentConfiguration): OccConfig => ({
  backend: {
    occ: {
      baseUrl: env.commerceBaseURL,
      endpoints: {
        product: {
          variants: 'products/${productCode}?fields=FULL',
          list: 'products/${productCode}?fields=FULL',
          details: 'products/${productCode}?fields=FULL',
        },
      },
    },
  },
});
